var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteKeypad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "default",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 20H7l-6-7.958L7 4h16v16zm0-17H7a.999.999 0 00-.801.402l-6 8.042a1 1 0 00.002 1.2l6 7.958c.19.251.485.398.799.398h16a1 1 0 001-1V4a1 1 0 00-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.143 17.857c.19.19.498.19.688 0L14 12.69l5.168 5.168c.191.19.5.19.69 0a.49.49 0 000-.689L14.69 12l5.168-5.168a.489.489 0 00-.69-.69L14 11.312l-5.168-5.17a.488.488 0 00-.69.69L13.31 12l-5.168 5.168a.49.49 0 000 .69"
  }))));
}
SvgDeleteKeypad.displayName = 'DeleteKeypad';
export default SvgDeleteKeypad;